import React from "react";

import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import LaunchIcon from "@mui/icons-material/Launch";

import { useTheme } from "@mui/material/styles";


interface MapPopupProps {
  id: number;

  streetAddress?: string;
  city?: string;
  state?: string;
  postCode?: string;
  country?: string;
  typeOfBuilding?: string;
}


const MapPopup: React.FC<MapPopupProps> = ({
  id,
  streetAddress,
  city,
  state,
  postCode,
  country,
  typeOfBuilding,
}) => {
  const theme = useTheme();


  /* -------------------------------------------------------------------------- */
  /* Address text                                                               */
  /* -------------------------------------------------------------------------- */

  const addressParts = [
    streetAddress,
    city,
    state,
    postCode,
    country,
  ].filter(Boolean);

  const addressText =
    addressParts.join(", ");


  /* -------------------------------------------------------------------------- */
  /* Navigate to address                                                        */
  /* -------------------------------------------------------------------------- */

  const handleViewAddress = () => {
    window.open(
        `/community/addresses/${id}/`,
        "_blank",
        "noopener,noreferrer"
    );
    };


  /* -------------------------------------------------------------------------- */
  /* Render                                                                     */
  /* -------------------------------------------------------------------------- */

  return (
    <Box
      sx={{
        position: "relative",

        minWidth: 220,

        pr: 4,

        backgroundColor:
          theme.custom.base.background.paper.dark,

        color:
          theme.custom.base.text.primary.dark,
      }}
    >
      {/* -------------------------------------------------------------------- */}
      {/* Launch button                                                        */}
      {/* -------------------------------------------------------------------- */}

      <Tooltip title="View Address">
        <IconButton
          size="small"
          onClick={handleViewAddress}
          sx={{
            position: "absolute",

            top: -6,
            right: -6,

            color:
              theme.custom.base.text.primary.dark,

            "&:hover": {
              backgroundColor:
                "rgba(255,255,255,0.08)",
            },
          }}
        >
          <LaunchIcon fontSize="small" />
        </IconButton>
      </Tooltip>


      {/* -------------------------------------------------------------------- */}
      {/* Address details                                                      */}
      {/* -------------------------------------------------------------------- */}

      <Stack spacing={0.75}>
        <Typography
          sx={{
            fontWeight: 600,

            fontSize: "15px",

            lineHeight: 1.3,

            color:
              theme.custom.base.text.primary.dark,
          }}
        >
          {streetAddress || "Address"}
        </Typography>


        {addressText && (
          <Typography
            sx={{
              fontSize: "13px",

              lineHeight: 1.4,

              color:
                theme.custom.base.text.primary.dark,
            }}
          >
            {addressText}
          </Typography>
        )}


        {typeOfBuilding && (
          <Typography
            sx={{
              fontSize: "12px",

              opacity: 0.7,

              color:
                theme.custom.base.text.primary.dark,
            }}
          >
            {typeOfBuilding}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};


export default MapPopup;